"use strict";

// Tools

import Tools from './Tools/Tools';

// Components

import Plyr from './Components/Plyr';
import Sharing from './Components/Sharing';

// Components

let TT = {

	init() {

		this.sharing = new Sharing();

		this.attachPlyr();
		this.placeCarousel();

		this.coffeeBreaksAssociation();

	},

	/**
	 * @author Raphaël TSINGOS
	 */
	attachPlyr() {
		new Plyr();
	},

	placeCarousel(){
		$('.place-carousel').flickity({
			// options
			prevNextButtons: false,
			pageDots: true,
			autoPlay: 5000,
			pauseAutoPlayOnHover: false,
			wrapAround: false,
			bgLazyLoad: true,
		});
	},

	coffeeBreaksAssociation(){
		$('.break-card').each((aIndex, aElement) => {
			let breakCard = $(aElement);
			breakCard.on('click touch', () => {
				let coffeeBreakUid = breakCard.data('coffee-break-uid').toString();
				breakCard.closest('.modal-body').find(".form-group[data-list-type='extras'] .form-group").each((bIndex, bElement) => {
					let checkbox = $(bElement);
					let coffeeBreakUids = checkbox.data('coffee-break-uids').toString();
					if(this.strstr(coffeeBreakUids, ',', false)) {
						let arrCoffeeBreakUids = coffeeBreakUids.split(',');
						if (arrCoffeeBreakUids.includes(coffeeBreakUid)) {
							checkbox.show(250);
						} else {
							checkbox.hide(250).find('INPUT').prop("checked", false);
						}
					}
					else{
						if(coffeeBreakUids === coffeeBreakUid){
							checkbox.show(250);
						}
						else{
							checkbox.hide(250).find('INPUT').prop("checked", false);
						}
					}
				});
			});
		});
	},

	strstr(haystack, needle, bool) {
		let pos = 0;
		haystack += "";
		pos = haystack.indexOf(needle); if (pos === -1) {
			return false;
		} else {
			if (bool) {
				return haystack.substr(0, pos);
			} else {
				return haystack.slice(pos);
			}
		}
	},

};

TT.init();